module.exports = __webpack_public_path__ + "img/blue_icon_1.923c5d55.svg";